import { render, staticRenderFns } from "./ArtistRow.vue?vue&type=template&id=03b11da2&scoped=true&"
import script from "./ArtistRow.vue?vue&type=script&lang=js&"
export * from "./ArtistRow.vue?vue&type=script&lang=js&"
import style0 from "./ArtistRow.vue?vue&type=style&index=0&id=03b11da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b11da2",
  null
  
)

export default component.exports